import { _BASE_Configuration } from '@/const/values.js';
const state = {
  skinType: _BASE_Configuration?1:0,
};

const mutations = {
  // eslint-disable-next-line no-shadow
  SKIN_TYPE: (state, skinType) => {
    state.skinType = skinType;
  },
};

const actions = {
  toggleDevice({ commit }, skinType) {
    commit('TOGGLE_DEVICE', skinType);
  },
};
export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
